import { observer } from "mobx-react";
import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { decodeToken, isExpired } from "react-jwt";
import BottomPlayer from "./components/BottomPlayer";
import Header from "./components/Header";
import MobileHeader from "./components/MobileHeader";
import StepperModal from "./modals/addNewTalentModals/StepperModal";
import Dashboard from "./pages/Dashboard";
import DashboardOld from "./pages/DashboardOld";
import Login from "./pages/Login";
import SearchResults from "./pages/SearchResults";
import Talents from "./pages/Talents";
import loginStore from "./stores/loginStore";
import voiceStore from "./stores/voiceStore";
import TalentDetails from "./modals/searchModals/TalentDetails";
import Users from "./pages/Users";
import axios from "axios";
import AddNewUserModal from "./modals/addNewUserModals/AddNewUserModal";
import userStore from "./stores/userStore";
import UpdateUserModal from "./modals/addNewUserModals/UpdateUserModal";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import projectStore from "./stores/projectStore";
import CreateProjectModal from "./modals/projectModals/CreateProjectModal";
import Years from "./pages/Projects/Years";
import Clients from "./pages/Projects/Clients";
import Projects from "./pages/Projects/Projects";
import ProjectDetail from "./pages/Projects/ProjectDetail";
import VideoModal from "./modals/VideoModal";
import NotFound from "./pages/NotFound";

import ViewSharedProject from "./pages/ViewSharedProject";
import AddToProjectModal from "./modals/projectModals/AddToProjectModal";
import AddTagsModal from "./modals/AddTagsModal";
import UpdateTalentDetailsModal from "./modals/talentModals/UpdateTalentDetailsModal";
import UpdateTalentVoicesModal from "./modals/talentModals/UpdateTalentVoicesModal";
import TalentBook from "./pages/TalentBook";


const App = observer(
  class App extends Component {
    constructor(props) {
      super(props);

      this.state = {
        login: false,
        init : true
      };
    }
    
    async componentDidMount() {
      const token = await localStorage.getItem("token");
      const currentVoiceStr = await localStorage.getItem("currentVoice");
      if(currentVoiceStr)
      {
        var currVoice = JSON.parse(currentVoiceStr);
        voiceStore.setCurrentVoice(currVoice);
       }
       else
      {
        voiceStore.setCurrentVoice(
          {
            talent_name : " ",
            profile_image_path : "",
            talent_id :"",
            sample_id : "",
            voice_modulation_path : "",
            voice_path : ""
          });
      }
 
      //console.log(voiceStore.currentVoice);
      if (token) {
        const isTokenExpired = isExpired(token);
        if (!isTokenExpired) {
          const decodedToken = decodeToken(token);
          loginStore.setUserData(decodedToken);
          
          axios.interceptors.request.use(
            async function (config) {
              if(config.url !== "/api/Login/RefreshToken")
              {
                const token = await localStorage.getItem("token");
                const isTokenExpired = isExpired(token);
                if (isTokenExpired) {
                  await loginStore.refreshToken();
                  
               
              }
            }
              return config;
            },
            function (error) {
              return Promise.reject(error);
            }
          );

          axios.interceptors.request.use(
            (config) => {
              if (token) {
                config.headers["Authorization"] = "Bearer " + token;
              }
              return config;
            },
            (error) => {
              return Promise.reject(error);
            }
          );

          this.setState({ login: true });
        } else {
          this.setState({ login: false });
        }
      } else {
        this.setState({ login: false });
      }
      this.setState({ init : false });
    }

    render() {
      const { login, init } = this.state;
      if(init === false)
      {
      return (
        <>
          {login && (
            <>
              <Header></Header>
              <MobileHeader></MobileHeader>
            </>
          )}
          
          <Routes>
            <Route
              path="/"
              element={login ? <Navigate to="/dashboard" /> : <Login />}
            />
            <Route
              path="/search"
              element={login ? <SearchResults /> : <Navigate to="/" />}
            />
            <Route
              path="/dashboard"
              element={login ? <Dashboard /> : <Navigate to="/" />}
            />
           <Route
              path="/dashboardold"
              element={login ? <DashboardOld /> : <Navigate to="/" />}
            />
            <Route
              path="/talents"
              element={login ? <TalentBook /> : <Navigate to="/" />}
            />
            <Route
              path="/talentbook"
              element={login ? <TalentBook /> : <Navigate to="/" />}
            />
            <Route
              path="/search-results"
              element={login ? <SearchResults /> : <Navigate to="/" />}
            />

            <Route
              path="/users"
              element={login ? <Users /> : <Navigate to="/" />}
            />

            {/* Projects */}
            <Route
              path="/projects"
              element={login ? <Years /> : <Navigate to="/" />}
            />
            <Route
              path="/projects/:year"
              element={login ? <Clients /> : <Navigate to="/" />}
            />
            <Route
              path="/projects/:year/:clientName"
              element={login ? <Projects /> : <Navigate to="/" />}
            />
            <Route
              path="/projects/:year/:clientName/:projectId"
              element={login ? <ProjectDetail /> : <Navigate to="/" />}
            />
             
            <Route
              path="/shared-projects/view/:projectId"
              element={<ViewSharedProject />}
            />

            <Route
              path="*"
              element={login ? <NotFound /> : <Navigate to="/" />}
            />
          </Routes>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            className="z-50"
          />

          {userStore.addNewUserModalVisible && <AddNewUserModal />}
          {userStore.updateUserModalVisible && <UpdateUserModal />}

          {voiceStore.stepperVisible && <StepperModal />}
          {voiceStore.talentDetailsModalVisible && <TalentDetails />}
          {voiceStore.updateTalentDetailsModalVisible && (
            <UpdateTalentDetailsModal />
          )}
          {voiceStore.updateTalentVoicesModalVisible && (
            <UpdateTalentVoicesModal />
          )}
          {voiceStore.currentVoice && login && (
            <div>
              <BottomPlayer></BottomPlayer>
            </div>
          )}

          {projectStore.createNewProjectModalVisible && <CreateProjectModal />}
         
          {projectStore.addToProjectModalVisible && <AddToProjectModal />}

          {projectStore.addTagsModalVisible && <AddTagsModal />}

          {voiceStore.videoModal && <VideoModal></VideoModal>}
        </>
      );
      }
       
  }
  }
);

export default App;
